import cn from 'classnames';
import CandidatePage from 'layouts/CandidatePage/CandidatePage';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { CustomButton } from '../components/CustomButton/CustomButton';
import { FormThanksCard } from 'components/FormThanksCard/FormThanksCard';

import { selectCandidateApplication } from 'api/candidate-application-slice';

const CandidateSuccess = () => {
  const { token } = useParams();

  const {
    application: { candidate, brand },
  } = useSelector(selectCandidateApplication);

  const handleClose = () => {
    if (brand?.click_through_candidate && brand?.click_through_candidate.trim() !== '')
      window.location.replace(brand.click_through_candidate);
    else window.location.replace('https://www.checkmate.tech/app/submission-confirmation');
  };

  return (
    <CandidatePage token={token} withTopLogo brand={brand} allowAfterSubmission>
      <CandidatePage.View>
        <CandidatePage.Card
          className={cn('d-flex', 'flex-column', 'align-items-center', 'u-gap-xx-large')}>
          <FormThanksCard candidate fullHeight={false} />
          <CustomButton brand={brand} dataTestId="close-button" onClick={handleClose}>
            Close
          </CustomButton>
        </CandidatePage.Card>
      </CandidatePage.View>
    </CandidatePage>
  );
};

export default CandidateSuccess;
